import React, { useState } from 'react';
import {
  Banner,
  Button,
  CondensedMedium,
  Flashy,
  Gutter,
  Icon,
  Layout,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Paragraph,
  ParagraphHeader,
} from '@axiom/ui';

export type ExperienceEditFormSkillsDeleteFocusAreaModalType = {
  name?: string;
  onClose: () => void;
  onSubmit: () => void;
};

export const ExperienceEditFormSkillsDeleteFocusAreaModal = ({
  name = 'EXPERIENCE_EDIT_FORM_SKILLS_DELETE_FOCUS_AREA_MODAL',
  onClose,
  onSubmit,
}: ExperienceEditFormSkillsDeleteFocusAreaModalType) => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  return (
    <Modal name={name} size="confirm">
      <ModalHeader
        name="DELETE_MODAL_HEADER"
        onClose={() => {
          onClose();
        }}
      >
        Delete Focus Area
      </ModalHeader>
      <ModalSection>
        <ParagraphHeader>Action required to delete focus area</ParagraphHeader>
        <Gutter bottom="16px" />
        <Paragraph>
          To delete this focus area, confirm that no focus areas apply to this
          experience or go back and add a different focus area before deleting
          this one.
        </Paragraph>
        <Gutter bottom="16px" />
        <Banner type="error">
          No Axiom focus areas apply to this experience.{' '}
          <Flashy bold>
            I confirm this is a non-legal experience or a legal area not
            supported by Axiom.
          </Flashy>
          <Gutter bottom="8px" />
          {isConfirmed ? (
            <CondensedMedium name="DELETE_CONFIRMED_MESSAGE">
              <Flashy color="dataVizGreen">
                <Layout position="middle" horizontalGutter="8px" inline>
                  <Flashy color="textDefault">Confirmed</Flashy>
                  <Icon name="circle-check-filled" />
                </Layout>
              </Flashy>
            </CondensedMedium>
          ) : (
            <Button
              name="CONFIRM_DELETE_BUTTON"
              onClick={() => {
                setIsConfirmed(true);
              }}
            >
              Confirm
            </Button>
          )}
        </Banner>
      </ModalSection>
      <ModalFooter>
        <Button
          name="DELETE_FOCUS_AREA_CANCEL"
          variation="outline"
          onClick={() => {
            onClose();
          }}
        >
          Go Back
        </Button>
        <Button
          name="DELETE_FOCUS_AREA_SUBMIT"
          onClick={() => {
            onSubmit();
          }}
          disabled={!isConfirmed}
        >
          Delete Focus Area
        </Button>
      </ModalFooter>
    </Modal>
  );
};
